import {
  Purchases,
  type PurchasesPackage,
} from '@revenuecat/purchases-capacitor';

import type { BillingAdapter, DisplayPackage, BillingCustomerInfo } from './BillingAdapter';

export class BillingNative implements BillingAdapter {
  async getOfferings(): Promise<{ availablePackages: DisplayPackage[] }> {
    const isReady = await Purchases.isConfigured();

    if (!isReady) return { availablePackages: [] }; 
        
    const offerings = await Purchases.getOfferings();
    const avail = offerings.current?.availablePackages ?? [];

    const display: DisplayPackage[] = avail.map((p: PurchasesPackage) => ({
      identifier: p.identifier,
      priceText: `${p.product.priceString}`,
      raw: p,
    }));

    return { availablePackages: display };
  }

  async getCustomerInfo(): Promise<BillingCustomerInfo> {
    const { customerInfo } = await Purchases.getCustomerInfo();
    return customerInfo as BillingCustomerInfo;
  }

  async purchasePackage(pkg: DisplayPackage): Promise<BillingCustomerInfo> {
    const aPackage = pkg.raw as PurchasesPackage;

    const { customerInfo } = await Purchases.purchasePackage({ aPackage });

    return customerInfo as BillingCustomerInfo;
  }

  async restorePurchases(): Promise<BillingCustomerInfo> {
    const { customerInfo } = await Purchases.restorePurchases();
    return customerInfo as BillingCustomerInfo;
  }

  async setAttributes(attributes: Record<string, string>): Promise<void> {
    await Purchases.setAttributes(attributes);
  }
}